import { DashboardRoutes } from "@simplyk/common";

export const MAGIC_LOGIN_ORGANIZATION_ID_PARAM = "organizationId";
export const MAGIC_LOGIN_EMAIL_PARAM = "email";
export const MAGIC_LOGIN_ROUTE_PARAM = "route";

export interface AdminMagicLoginParams {
  organizationId: string | null;
  email: string | null;
  route: string | null;
}

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const INTERNAL_PATH_REGEX = /^\/(?![/\\])\S*$/;

const readQueryParam = (value: string | null | undefined): string | null => {
  const trimmedValue = typeof value === "string" ? value.trim() : "";
  return trimmedValue === "" ? null : trimmedValue;
};

export const sanitizeInternalPath = (value: string | null | undefined): string | null => {
  const path = readQueryParam(value);
  return path && INTERNAL_PATH_REGEX.test(path) ? path : null;
};

interface QueryParams {
  get: (name: string) => string | null;
}

export const parseAdminMagicLoginParams = (searchParams: QueryParams): AdminMagicLoginParams => {
  const organizationId = readQueryParam(searchParams.get(MAGIC_LOGIN_ORGANIZATION_ID_PARAM));
  const email = readQueryParam(searchParams.get(MAGIC_LOGIN_EMAIL_PARAM));

  return {
    organizationId: organizationId && UUID_REGEX.test(organizationId) ? organizationId : null,
    email: email && email.includes("@") ? email.toLowerCase() : null,
    route: sanitizeInternalPath(searchParams.get(MAGIC_LOGIN_ROUTE_PARAM)),
  };
};

export const buildAdminMagicLoginPath = ({
  organizationId,
  email,
  route,
}: Partial<AdminMagicLoginParams>): string | null => {
  if (!organizationId && !email) {
    return null;
  }

  const params = new URLSearchParams();
  if (organizationId) {
    params.set(MAGIC_LOGIN_ORGANIZATION_ID_PARAM, organizationId);
  }
  if (email) {
    params.set(MAGIC_LOGIN_EMAIL_PARAM, email);
  }
  const internalRoute = sanitizeInternalPath(route);
  if (internalRoute) {
    params.set(MAGIC_LOGIN_ROUTE_PARAM, internalRoute);
  }

  return `${DashboardRoutes.MagicLoginAdmin}?${params.toString()}`;
};

export const buildAdminMagicLoginUrl = (params: Partial<AdminMagicLoginParams> & { origin: string }): string | null => {
  const path = buildAdminMagicLoginPath(params);
  return path ? `${params.origin}${path}` : null;
};
